.section {
  padding: var(--space-6) var(--space-6) var(--space-5);
  text-align: center;
  background: #fff;
  font-family: "Montserrat", "Roboto", sans-serif;
}

.title {
  margin: 0 0 var(--space-3);
  font-size: 1.5rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-ink);
}

.body,
.emphasis {
  margin: 0 auto var(--space-3);
  max-width: 720px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--color-ink-soft);
}

.emphasis {
  margin-bottom: 0;
  font-weight: 600;
  color: var(--color-ink);
}
